export default function Footer() {
  return (
    <footer className="bg-[#F0F8FF] py-16 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#0077B6] rounded-full transform -translate-x-32 -translate-y-32 opacity-10"></div>
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#0077B6] rounded-full transform translate-x-32 translate-y-32 opacity-10"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="bg-white rounded-3xl p-12 shadow-lg">
          <div className="grid md:grid-cols-5 gap-12 mb-10">
            {/* Brand Block */}
            <div className="md:col-span-2">
              <h5 className="text-2xl font-bold text-[#0077B6] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                West Insurance
              </h5>
              <address className="not-italic text-gray-600 text-sm leading-relaxed mb-4">
                <strong>243 La Reata Rd S</strong><br />
                Kerrville, TX 78028<br />
                <a href="tel:830-203-6201" className="hover:text-[#0077B6] cursor-pointer">Phone: 830-203-6201</a><br />
                <a href="mailto:info@westinsurance.com" className="hover:text-[#0077B6] cursor-pointer">info@westinsurance.com</a>
              </address>
              <p className="text-sm font-semibold text-[#0077B6]">Serving Kerrville & Kerr County, TX</p>
            </div>

            {/* Health Insurance Column */}
            <div>
              <h6 className="text-xs font-bold text-gray-900 tracking-wider mb-4">HEALTH INSURANCE</h6>
              <ul className="space-y-2 text-sm text-gray-600">
                <li><a href="/private-health-insurance-kerrville-tx" className="hover:text-[#0077B6] cursor-pointer">Private Health Insurance</a></li>
                <li><a href="/group-health-insurance-kerrville-tx" className="hover:text-[#0077B6] cursor-pointer">Group Health Insurance</a></li>
                <li><a href="/medicare-kerrville-tx" className="hover:text-[#0077B6] cursor-pointer">Medicare Plans</a></li>
                <li><a href="/medicare-kerrville-tx" className="hover:text-[#0077B6] cursor-pointer">Medicare Advantage</a></li>
                <li><a href="/dental-insurance-kerrville-tx" className="hover:text-[#0077B6] cursor-pointer">Dental Insurance</a></li>
              </ul>
            </div>

            {/* Company Column */}
            <div>
              <h6 className="text-xs font-bold text-gray-900 tracking-wider mb-4">COMPANY</h6>
              <ul className="space-y-2 text-sm text-gray-600">
                <li><a href="#about" className="hover:text-[#0077B6] cursor-pointer">About</a></li>
                <li><a href="#testimonials" className="hover:text-[#0077B6] cursor-pointer">Testimonials</a></li>
                <li><a href="#location" className="hover:text-[#0077B6] cursor-pointer">Location</a></li>
                <li><a href="#contact" className="hover:text-[#0077B6] cursor-pointer">Contact</a></li>
              </ul>
            </div>

            {/* Resources Column */}
            <div>
              <h6 className="text-xs font-bold text-gray-900 tracking-wider mb-4">RESOURCES</h6>
              <ul className="space-y-2 text-sm text-gray-600">
                <li><a href="#contact" className="hover:text-[#0077B6] cursor-pointer">Get Free Quote</a></li>
                <li><a href="tel:830-203-6201" className="hover:text-[#0077B6] cursor-pointer">Medicare Help</a></li>
                <li><a href="tel:830-203-6201" className="hover:text-[#0077B6] cursor-pointer">Group Plans</a></li>
                <li><a href="#contact" className="hover:text-[#0077B6] cursor-pointer">Contact Us</a></li>
              </ul>
            </div>
          </div>

          {/* Business Directory Listings */}
          <div className="py-8 border-t border-gray-200">
            <h6 className="text-xs font-bold text-gray-900 tracking-wider mb-4 text-center">FIND US ONLINE</h6>
            <div className="flex flex-wrap justify-center gap-3">
              <a
                href="https://www.a-zbusinessfinder.com/business-directory/West-Health-Insurance-Kerrville-Texas-USA/34461555/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 bg-gray-50 border border-gray-200 rounded-full text-xs text-gray-600 hover:text-[#0077B6] hover:border-[#0077B6] hover:bg-[#F0F8FF] transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-map-pin-line text-sm"></i>
                A-Z Business Finder
              </a>
              <a
                href="https://us.enrollbusiness.com/BusinessProfile/7731496/West%20Health%20Insurance"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 bg-gray-50 border border-gray-200 rounded-full text-xs text-gray-600 hover:text-[#0077B6] hover:border-[#0077B6] hover:bg-[#F0F8FF] transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-building-2-line text-sm"></i>
                Enroll Business
              </a>
              <a
                href="https://bizidex.com/en/west-health-insurance-insurance-880929"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 bg-gray-50 border border-gray-200 rounded-full text-xs text-gray-600 hover:text-[#0077B6] hover:border-[#0077B6] hover:bg-[#F0F8FF] transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-global-line text-sm"></i>
                Bizidex
              </a>
              <a
                href="https://www.zipleaf.us/Companies/West-Health-Insurance"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 bg-gray-50 border border-gray-200 rounded-full text-xs text-gray-600 hover:text-[#0077B6] hover:border-[#0077B6] hover:bg-[#F0F8FF] transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-file-list-3-line text-sm"></i>
                Zipleaf
              </a>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-gray-200">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <div className="text-sm text-gray-600">
                © 2025 West Insurance. All rights reserved. | 
                <a href="#" className="hover:text-[#0077B6] ml-1 cursor-pointer">Privacy Policy</a> | 
                <a href="#" className="hover:text-[#0077B6] ml-1 cursor-pointer">Terms of Service</a> | 
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#0077B6] ml-1 cursor-pointer">Powered by Readdy</a>
              </div>
              <div className="flex items-center gap-4">
                <a
                  href="https://www.facebook.com/WestHealthInsurance"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-10 h-10 bg-[#0077B6] text-white rounded-full flex items-center justify-center hover:bg-[#005F8C] transition-all cursor-pointer"
                  aria-label="Facebook"
                >
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a
                  href="https://www.instagram.com/westhealthinsurance/"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-10 h-10 bg-[#0077B6] text-white rounded-full flex items-center justify-center hover:bg-[#005F8C] transition-all cursor-pointer"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a
                  href="https://x.com/westhealthinsur"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-10 h-10 bg-[#0077B6] text-white rounded-full flex items-center justify-center hover:bg-[#005F8C] transition-all cursor-pointer"
                  aria-label="X (Twitter)"
                >
                  <i className="ri-twitter-x-line text-lg"></i>
                </a>
                <a
                  href="https://www.linkedin.com/company/westhealthinsurance/"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-10 h-10 bg-[#0077B6] text-white rounded-full flex items-center justify-center hover:bg-[#005F8C] transition-all cursor-pointer"
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
